var isBrowser = typeof window !== 'undefined';
const $ = isBrowser ? window.$ : {};
var React = require('react');
var createReactClass = require('create-react-class');
var ReactRedux = require("react-redux");
var bindActionCreators = require("redux").bindActionCreators;
var PropTypes = require('prop-types');
var cookie = require('react-cookie');
var actions = require('../../modules/facebook-like-modal/actions/facebook-like-modal');

var enableFacebookLikeModal = function(Component) {
    var EnabledComponent = createReactClass({
        componentDidMount: function() {
            this.context.router.listen(function(){
                if(this.props.showFacebookLikeModal === true){
                    this.props.closeFacebookLikeModal('route change');
                }
            }.bind(this));

            this.registerLeavingViewportTrigger();

            this.registerPageviewTrigger();

            this.registerStayingEducationTrigger();
        },

        render: function() {
            return (
                <Component {...this.props} />
            );
        },

        // for making this.context.router available
        contextTypes: {
            router: PropTypes.object.isRequired
        },

        registerPageviewTrigger: function(){
            var pageviews = 0;

            this.context.router.listen(function(location){
                if(location.action !== 'REPLACE'){
                    pageviews++;
                }

                if(!cookie.load('doNotDisturb') && !this.props.showFacebookLikeModal && pageviews > 3){
                    this.props.openFacebookLikeModal('pageview');
                }
            }.bind(this));
        },

        registerLeavingViewportTrigger: function(){
            $(document).mouseleave(function(){
                if(!cookie.load('doNotDisturb') && !this.props.showFacebookLikeModal){
                    this.props.openFacebookLikeModal('leaving viewport');
                }
            }.bind(this));
        },

        registerStayingEducationTrigger: function(){
            var stayingTimer = 'nope';

            this.context.router.listen(function(location){
                if(stayingTimer !== 'nope'){
                    clearTimeout(stayingTimer);
                    stayingTimer = 'nope';
                }

                if(!cookie.load('doNotDisturb') && !this.props.showFacebookLikeModal && location.pathname.startsWith('/education')){
                    stayingTimer = setTimeout(function(){
                        if(!cookie.load('doNotDisturb') && !this.props.showFacebookLikeModal){
                            this.props.openFacebookLikeModal('education trigger');
                        }
                    }.bind(this), 120000 /* 2 minutes in millisecond */);
                }
            }.bind(this));
        }
    });

    var mapStateToProps = function(state){
        return {
            showFacebookLikeModal: state.showFacebookLikeModal
        };
    }

    var mapDispatchToProps = function(dispatch) {
        return bindActionCreators(Object.assign({}, actions), dispatch);
    }

    return ReactRedux.connect(mapStateToProps, mapDispatchToProps)(EnabledComponent);
};

module.exports = enableFacebookLikeModal;



// WEBPACK FOOTER //
// ./src/common/routes/components/enableFacebookLikeModal.jsx